import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { SecurityService } from 'app/services/security.service';
import { catchError, map, of } from 'rxjs';

export const list06Guard: CanActivateFn = (route, state) => {
  const _securityService = inject(SecurityService);
  const _router = inject(Router);

  return _securityService.getCheckpoint().pipe(
      map((response: any) => {
        const checkpoint = response.checkpoint;
        if(checkpoint === 'LIST_ERROR_06'){
          _router.navigateByUrl('/error')
          return false
        }else{
          return true
        }
        
      }),
      catchError((error: any) => {
        console.error("Error en el Guard: ", error);
        _router.navigateByUrl('');
        return of(false);})
    );
};
